import { useEffect, useState } from 'react';
import type { Session, SupabaseClient } from '@supabase/supabase-js';

export type SessionState =
  | { readonly status: 'loading' }
  | { readonly status: 'signed-out' }
  | { readonly status: 'signed-in'; readonly session: Session };

/** Current Supabase session, kept up to date by onAuthStateChange (sign-in from a link, refresh, sign-out). */
export function useSession(sb: SupabaseClient): SessionState {
  const [state, setState] = useState<SessionState>({ status: 'loading' });
  useEffect(() => {
    let live = true;
    sb.auth
      .getSession()
      .then(({ data }) => {
        if (live)
          setState(data.session ? { status: 'signed-in', session: data.session } : { status: 'signed-out' });
      })
      .catch(() => live && setState({ status: 'signed-out' }));
    const { data } = sb.auth.onAuthStateChange((_event, session) => {
      if (live) setState(session ? { status: 'signed-in', session } : { status: 'signed-out' });
    });
    return () => {
      live = false;
      data.subscription.unsubscribe();
    };
  }, [sb]);
  return state;
}
